/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum QaLoginPage {
  inputEmail = 'login-page_email',
  inputPassword = 'login-page_password',
  buttonSignIn = 'login-page_signin',
  linkForgotUsername = 'login-page_forgot-username',
  linkForgotPassword = 'login-page_forgot-password',
  textCustomerSupport = 'login-page_customer-support',
  textFooter = 'login-page_footer',
  linkTermsOfService = 'login-page_terms-of-service',
  linkPrivacyPolicy = 'login-page_privacy-policy',
  textTitle = 'login-page_text-title',
  textToastAlert = 'login-page_text-toast-alert',
  buttonVerificationChannel = 'login-page_button-verification-channel-',
}

export enum QaDashboardPage {
  inputSearch = 'dashboard-page_search',
  buttonUnlockVault = 'component-digital-vault_unlock',
  buttonCreateMasterPassword = 'component-digital-vault_button-create-master-password',
  textPageTitle = 'dashboard-page_text-page-title',

  // sidebar — accordion section rows, generated as `sidebar_section_<section key>`
  sectionMedical = 'sidebar_section_medical',
  sectionIdentity = 'sidebar_section_identity',
  sectionPrivacy = 'sidebar_section_privacy',
  sectionCredit = 'sidebar_section_credit',
  sectionFinancial = 'sidebar_section_financial',
  sectionSecurity = 'sidebar_section_security',

  // data-collection / PII-required banner
  bannerPiiRequired = 'dashboard-page_banner-pii-required',
  textBannerPiiRequired = 'dashboard-page_text-banner-pii-required',
  buttonBannerPiiActivateNow = 'dashboard-page_button-banner-pii-activate-now',
}

export enum QADashboardPageAlerts {
  cardAlerts = 'dashboard-page_card-alerts',
  textTitle = 'dashboard-page_card-alerts-title',
  textBadge = 'dashboard-page_card-alerts-badge',
  textBody = 'dashboard-page_card-alerts-body',
  textAlertCount = 'dashboard-page_card-alerts-count',
  textAlertCountLabel = 'dashboard-page_card-alerts-count-label',
  iconHeader = 'dashboard-page_card-alerts-icon-header',
  iconBody = 'dashboard-page_card-alerts-icon-body',
  buttonCta = 'dashboard-page_card-alerts-button-cta',
}

export enum QAAlertsPage {
  page = 'alerts-page',
  textTitle = 'alerts-page_text-title',
  statusNewAlerts = 'alerts-page_status-new-alerts',
  emptyState = 'alerts-page_empty-state',
  textHeaderUnreadCount = 'alerts-page_text-unread-count',
  // Active / Archived view switch — two tabs above the filter chip row.
  viewSwitchActive = 'alerts-page_view-switch-active',
  viewSwitchArchived = 'alerts-page_view-switch-archived',
  // Filter pills — suffix with the filter group key, e.g. -all, -darkWeb, -identity.
  filterChip = 'alerts-page_filter-chip',
  // Archive / Restore primary button inside the expanded alert panel.
  cardArchiveButton = 'alerts-page_card-archive-button',
  // Alert card (collapse header). Read/unread state is conveyed by the
  // existing "unread" class antd applies to the collapse item and by the
  // presence of the cardBadgeNew "New" badge — no extra attribute is added.
  card = 'alerts-page_card',
  cardBadgeNew = 'alerts-page_card-badge-new',
  cardTextDate = 'alerts-page_card-text-date',
  // Alert type name (ALERT_TYPES[group]) — the sort tiebreak key.
  cardTextType = 'alerts-page_card-text-type',
  cardIconType = 'alerts-page_card-icon-type',
  // Expanded detail panel revealed when a card is opened.
  cardDetail = 'alerts-page_card-detail',
  // Detail field grid (PanelContent). Individual fields are read by their existing
  // rendered label text within this grid — no per-field attribute is added.
  cardDetailGrid = 'alerts-page_card-detail-grid',
  // "Why did you receive this alert?" section (WhyDidIReceiveAlert).
  cardWhySection = 'alerts-page_card-why-section',
  cardWhyBody = 'alerts-page_card-why-body',
  // "Don't recognize this activity?" toggle + the content it reveals (AlertAction).
  cardDontRecognizeToggle = 'alerts-page_card-dont-recognize-toggle',
  cardDontRecognizeContent = 'alerts-page_card-dont-recognize-content',
  pagination = 'alerts-page_pagination',
  paginationSize = 'alerts-page_pagination-size',
  // Identity-verification banner shown to users with restricted (gated) alerts.
  // The gated-alert count is read from this banner's existing title text, and
  // its CTA button is reached by role within this labeled container.
  bannerVerifyIdentity = 'alerts-page_banner-verify-identity',
}

export enum QABankAccountMonitoringPage {
  page = 'bank-account-monitoring-page',
  textTitle = 'bank-account-monitoring-page_text-title',
  textDescription = 'bank-account-monitoring-page_text-description',
  textTriggersHeader = 'bank-account-monitoring-page_text-triggers-header',
  // The four trigger cards share one selector; scope by index in the test.
  cardTrigger = 'bank-account-monitoring-page_card-trigger',
  cardTriggerIcon = 'bank-account-monitoring-page_card-trigger-icon',
  cardTriggerTitle = 'bank-account-monitoring-page_card-trigger-title',
  cardTriggerDescription = 'bank-account-monitoring-page_card-trigger-description',
}

export enum QADashboardPageDboo {
  buttonActivate = 'dashboard-page-dboo_activate',
  buttonReview = 'dashboard-page-dboo_review',
  textOptOutsInProgress = 'dashboard-page-dboo_in-progress',
  textOptOutsSuccess = 'dashboard-page-dboo_success',

  // dashboard page -> dboo card
  cardDboo = 'dashboard-page_card-dboo',
  cardDbooTitle = 'dashboard-page_card-dboo-title',
  cardDbooDescription = 'dashboard-page_card-dboo-description',
}

export enum QaDbooComponent {
  buttonActivate = 'component-dboo_activate-opt-out',
  buttonReviewRequests = 'component-dboo_review-requests',
}

export enum QaDbooPage {
  textSuccessfulOptOuts = 'successful opt outs',
  textInProgressOptOuts = 'dboo-page_in-progress-opt-outs',
  textOptOutsCount = 'dboo-page_count-',
  textNextOptOut = 'next scheduled opt out',
  buttonDeactivateOptOut = 'dboo-page_deactivate-opt-out',
  buttonActivateOptOut = 'component-dboo_activate-opt-out',

  // 'Information required to activate Data Broker Opt Out' modal
  textModalActivateOptOutTitle = 'dboo-page_modal-activate-opt-out-title',
  textModalActivateOptOutDescription = 'dboo-page_modal-activate-opt-out-description',

  // 'Unblock now' modal
  textUnblockNowTitle = 'dboo-page_unblock-now-title',
  textUnblockNowDescription = 'dboo-page_unblock-now-description',
  textUnblockNowAlert = 'dboo-page_unblock-now-alert',
  buttonUnblockNowCancel = 'dboo-page_unblock-now-cancel',
  buttonUnblockNowSubmit = 'dboo-page_unblock-now-submit',

  buttonUnblock = 'dboo-page_unblock',
}

export enum QaDbooActivateModal {
  buttonPrevious = 'dboo-activate-modal_previous',
  buttonFinish = 'dboo-activate-modal_finish',

  // legal name
  inputFirstName = 'dboo-activate-modal_first-name',
  inputMiddleName = 'dboo-activate-modal_middle-name',
  inputLastName = 'dboo-activate-modal_last-name',
  dropdownSuffix = 'dboo-activate-modal_suffix',
  textTitleLegalName = 'dboo-activate-modal_title-legal-name',

  // dob, phone, ssn, email

  textTitleDob = 'dboo-activate-modal_title-dob',
  textTitleAddress = 'dboo-activate-modal_title-address',

  // checkbox
  checkbox = 'dboo-activate-modal_checkbox',
}

export enum QaDbooDeactivateModal {
  textHeader = 'dboo-deactivate-modal_header',
  textSubheader = 'dboo-deactivate-modal_subheader',
}

export enum QaPrivateSearchComponent {
  inputSearchTerm = 'component-private-search_search-term',
  buttonSubmitSearch = 'component-private-search_submit',
}

export enum QaMasterPasswordModal {
  inputMasterPassword = 'modal-master-password_input-password',
  buttonUnlock = 'modal-master-password_unlock',
  textErrorMessage = 'modal-master-password_error-message',
  textTitle = 'modal-master-password_text-title',
  linkForgotMasterPassword = 'modal-master-password_link-forgot-master-password',
  buttonCancel = 'modal-master-password_button-cancel',
}

export enum QaDigitalVault {
  buttonAddDocument = 'component-digital-vault_add-doc',
  textDocumentCount = 'component-digital-vault_doc-count',

  textTitleNoDocuments = 'component-digital-vault_title_no_documents',
  buttonSearchDocuments = 'component-digital-vault_search_documents',
  buttonClearSearch = 'component-digital-vault_clear_search',
  inputSearchDocuments = 'component-digital-vault_input_search_documents',
  buttonDocumentContainer = 'component-digital-vault_document-container',
  dropdownDocument = 'component-digital-vault_document-dropdown_',

  // document page
  textItemType = 'component-digital-vault_item-type',
  textItemName = 'component-digital-vault_item-name',
  textItemDescription = 'component-digital-vault_item-description',
  textAttachmentName = 'component-digital-vault_attachment-name_',
  textNoSearchResults = 'component-digital-vault_no_search_results',
  dropdownAttachment = 'component-digital-vault_attachment-dropdown_',

  // delete document modal
  buttonDocumentDelete = 'modal-delete-document_delete',

  // delete attachment modal
  buttonAttachmentDelete = 'modal-delete-attachment_delete',
}

export enum QaDigitalVaultAddDoc {
  inputTitle = 'modal-add-document_name',
  inputDescription = 'modal-add-document_description',
  buttonSaveInVault = 'modal-add-document_button-save-in-vault',
  buttonAddAttachment = 'modal-add-document_add-attachment',
  alertFileErrorMessage = 'modal-add-document_file-error-message',
  alertSelectItemError = 'modal-add-document_select-item-error-message',
}

export enum QaDigitalVaultEditDoc {
  inputDocName = 'modal-edit-doc_input-document-name',
  inputDocDescription = 'modal-edit-doc_input-document-description',
  buttonSaveChanges = 'modal-edit-document_button-save-changes',
}

export enum QaDarkWebMonitoringComponent {
  // personal information items
  buttonPersonalInfo = 'component-dwm_personal-info',
  buttonAddName = 'component-dwm_add-name',
  buttonAddDob = 'component-dwm_add-dob',
  buttonAddSsn = 'component-dwm_add-ssn',
  buttonAddMothersMaidenName = 'component-dwm_add-mothers-maiden-name',
  buttonAddEmail = 'component-dwm_add-email',
  buttonAddPhone = 'component-dwm_add-phone',
  buttonAddHomeAddress = 'component-dwm_add-home-address',
  buttonAddIpAddress = 'component-dwm_add-ip-address',

  // identification information items
  buttonIdentificationInfo = 'component-dwm_identification-info',
  buttonAddDriversLicense = 'component-dwm_add-drivers-license',
  buttonAddHealthInsurance = 'component-dwm_add-health-insurance',
  buttonAddPasspord = 'component-dwm_add-passport',
  buttonAddGreenCard = 'component-dwm_add-greencard',
  buttonAddTaxpayerId = 'component-dwm_add-taxpayer-id',
  buttonAddNpi = 'component-dwm_add-npi',

  // financial information items
  buttonFinancialInfo = 'component-dwm_financial-info',
  buttonAddCreditCard = 'component-dwm_add-credit-card',
  buttonAddFinancialAccount = 'component-dwm_add-financial-account',
  buttonAddLoyaltyCard = 'component-dwm_add-loyalty-card',

  // username items
  buttonUsername = 'component-dwm_username',
  buttonAddGamertag = 'component-dwm_add-gamertag',
  buttonAddFacebook = 'component-dwm_add-facebook',
  buttonAddInstagram = 'component-dwm_add-instagram',
  buttonAddPaypal = 'component-dwm_add-paypal',
  buttonAddTelegram = 'component-dwm_add-telegram',
  buttonAddTwitter = 'component-dwm_add-twitter',
  buttonAddVenmo = 'component-dwm_add-venmo',
  buttonAddYoutube = 'component-dwm_add-youtube',
  buttonAddOthers = 'component-dwm_add-others',

  // medical data
  buttonMedicalBeneficiary = 'component-dwm_medical-beneficiary',
  buttonMedicalRecordNumber = 'component-dwm_add-medical-record-number',

  // add dwm item modal
  buttonCancel = 'component-dwm_cancel',
  buttonSave = 'component-dwm_save',
  inputMothersMaidenName = 'component-dwm_input-mothers-maiden-name',
  dropdownPhoneNumberType = 'component-dwm_dropdown-phone-number-type',
  inputHomeAddressStreet = 'component-dwm_input-home-address-street',
  inputHomeAddressApartment = 'component-dwm_input-home-address-apartment',
  inputNetworkIpAddress = 'component-dwm_input-network-ip-address',
  inputNetworkDeviceName = 'component-dwm_input-network-device-name',
  inputDriverLicenseNumber = 'component-dwm_input-driver-license-number',
  inputHealthInsuranceProviderName = 'component-dwm_input-health-insurance-provider-name',
  inputHealthInsuranceIdNumber = 'component-dwm_input-health-insurance-id-number',
  inputPassportNumber = 'component-dwm_input-passport',
  dropdownVisaDocumentType = 'component-dwm_dropdown-visa-document-type',
  inputVisaDocumentNumber = 'component-dwm_input-visa-document-number',
  inputTaxpayerIdentificationNumber = 'component-dwm_input-taxpayer-identification-number',
  inputNationalProviderIdentifier = 'component-dwm_input-national-provider-identifier',
  inputCreditCardNumber = 'component-dwm_input-credit-card-number',
  dropdownFinancialAccountType = 'component-dwm_dropdown-financial-account-type',
  inputFinancialAccountNumber = 'component-dwm_input-financial-account-number',
  dropdownCryptoWalletType = 'component-dwm_dropdown-crypto-wallet-type',
  inputCryptoWalletID = 'component-dwm_input-crypto-wallet-id',
  inputLoyaltyCardName = 'component-dwm_input-loyalty-card-name',
  inputLoyaltyCardNumber = 'component-dwm_input-loyalty-card-number',
  inputGamertag = 'component-dwm_input-gamertag',
  inputFacebookUsername = 'component-dwm_input-facebook-username',
  inputInstagramUsername = 'component-dwm_input-instagram-username',
  inputPayPalUsername = 'component-dwm_input-paypal-username',
  inputTelegramUsername = 'component-dwm_input-telegram-username',
  inputTwitterHandle = 'component-dwm_input-twitter-handle',
  inputVenmoUsername = 'component-dwm_input-venmo-username',
  inputYouTubeHandle = 'component-dwm_input-youtube-handle',
  inputOtherAccountName = 'component-dwm_input-other-account-name',
  inputOtherUsername = 'component-dwm_input-other-username',
  inputHealthcareOrgName = 'component-dwm_input-healthcare-org-name',
  inputMedicalRecordNumber = 'component-dwm_input-medical-record-number',
  inputMedicalBeneficiaryId = 'component-dwm_input-medical-beneficiary-id',
  inputMedicalCannabisId = 'component-dwm_input-medical-cannabis-id-number',

  containerAddItemModal = 'component-dwm_container-add-item-modal',

  textModalTitle = 'component-dwm_text-modal-title',
  textModalDescription = 'component-dwm_text-modal-description',

  tooltipAddItem = 'component-dwm_tooltip-add-item',

  alertInputErrorMessage = 'component-dwm_alert-input-error-message',

  // remove dwm item modal
  buttonRemoveItem = 'component-dwm_button-remove-item-',

  containerRemoveItemModal = 'component-dwm_container-remove-item-modal',
  textRemoveItemModalTitle = 'component-dwm_text-remove-item-modal-title',
  textRemoveItemModalDescription = 'component-dwm_text-remove-item-modal-description',
  buttonRemoveItemModalCancel = 'component-dwm_button-remove-item-modal-cancel',
  buttonRemoveItemModalRemove = 'component-dwm_button-remove-item-modal-remove',

  // dashboard page -> dwm card
  buttonAddToWatchlist = 'component-dwm_card-button-add-to-watchlist',
}

export enum QaPasswordScanComponent {
  inputPassword = 'component-password-scan_input-password',
  buttonCheckPassword = 'component-password-scan_check-password',
  textPasswordScanResult = 'component-password-scan_scan-result',
  textTermsOfService = 'component-password-scan_terms-of-service',
  textErrorMessage = 'component-password-scan_error-message',
}

export enum QaCommonComponent {
  buttonContinue = 'component-common_button-continue',
  buttonCancel = 'component-common_button-cancel',
  buttonModalClose = 'button-modal-close',
  alertGlobalToast = 'global-toast-alert',
  spinnerLoading = 'component-common_spinner-loading',
}

export enum QaHeader {
  dropdownProfileMenu = 'dropdown_profile-menu',
  dropdownItemMyAccount = 'dropdown-item_my-account',
  dropdownItemSignOut = 'dropdown-item_sign-out',
  containerHeader = 'header_container-header',
  linkLogo = 'header_link-logo',
  imageLogo = 'header_image-logo',
  linkCustomerSupportPhone = 'header_link-customer-support-phone',
  iconNotification = 'header_icon-notification',
  badgeNotificationUnread = 'header_badge-notification-unread',
  containerNotificationPopover = 'header_container-notification-popover',
  textNotificationContent = 'header_text-notification-content',
  buttonNotificationDismiss = 'header_button-notification-dismiss',
}

export enum QaMyAccountPage {
  buttonDetailsInfo = 'my-account-page_button-',
}

export enum QaSecurityPage {
  buttonEnable2FA = 'security-page_button-enable-2fa',
  buttonVerificationMethod = 'security-page_select-verification-method-',
  inputVerificationSms = 'security-page_input-verification-sms',
  inputVerificationEmail = 'security-page_input-verification-email',
  inputVerificationCall = 'security-page_input-verification-call',
  buttonVerificationGoBack = 'security-page_button-verification-back',
  buttonVerificationConfirm = 'security-page_button-verification-confirm',
  checkboxSmsOptIn = 'security-page_checkbox-sms-opt-in',
  divChannelItem = 'security-page_channel-item-',
  buttonMoreActions = 'security-page_button-more-actions-',
  linkRemoveChannel = 'security-page_link-remove-channel-',
  badgeOn = 'security-page_badge-on',
  buttonAddAnotherMethod = 'security-page_button-add-another-method',
}

export enum Qa2faModal {
  inputVerificationCode = 'modal-2fa_input-verification-code',
  buttonCancel = 'modal-2fa_button-cancel',
  buttonSubmit = 'modal-2fa_button-submit',
  buttonRequestNewCode = 'modal-2fa_button-request-new-code',
  textError = 'modal-2fa_text-error',
}

export enum QaAccountDetailsPage {
  textTitle = 'account-details-page_text-title',
  textSectionTitle = 'account-details-page_text-section-title-',
  textCardTitle = 'account-details-page_text-card-title-',
  textCardSubtitle = 'account-details-page_text-card-subtitle-',
  buttonUpdate = 'account-details-page_button-update-',
  buttonAdd = 'account-details-page_button-add-',
  iconLocked = 'account-details-page_icon-locked-',
}

export enum QaUpdateUsernameModal {
  modalUpdateUsername = 'modal-upd-username_modal',
  textTitle = 'modal-upd-username_text-title',
  inputUsername = 'modal-upd-username_input-username',
  buttonSaveChanges = 'modal-upd-username_button-save-changes',
  buttonCancel = 'modal-upd-username_button-cancel',
  textToastError = 'modal-upd-username_text_toast-error',
  textInputError = 'modal-upd-username_input-username-error',
}

export enum QaUpdateNameModal {
  modalUpdateName = 'modal-upd-name_modal',
  textTitle = 'modal-upd-name_text-title',
  buttonSaveChanges = 'modal-upd-name_button-save-changes',
  buttonCancel = 'modal-upd-name_button-cancel',
}

export enum QaUpdateDobModal {
  modalUpdateDob = 'modal-upd-dob_modal',
  textTitle = 'modal-upd-dob_text-title',
  buttonSaveChanges = 'modal-upd-dob_button-save-changes',
  buttonCancel = 'modal-upd-dob_button-cancel',
}

export enum QaUpdateSsnModal {
  modalUpdateSsn = 'modal-upd-ssn_modal',
  textTitle = 'modal-upd-ssn_text-title',
  buttonSaveChanges = 'modal-upd-ssn_button-save-changes',
  buttonCancel = 'modal-upd-ssn_button-cancel',
}

export enum QaUpdatePhoneModal {
  modalUpdatePhone = 'modal-upd-phone_modal',
  textTitle = 'modal-upd-phone_text-title',
  inputPhoneNumber = 'modal-upd-phone_input-phone-number',
  buttonSaveChanges = 'modal-upd-phone_button-save-changes',
  buttonCancel = 'modal-upd-phone_button-cancel',
}

export enum QaUpdateAddressModal {
  modalUpdateAddress = 'modal-upd-address_modal',
  textTitle = 'modal-upd-address_text-title',
  checkboxNcoaOptOut = 'modal-upd-address_checkbox-ncoa-opt-out',
  buttonSaveChanges = 'modal-upd-address_button-save-changes',
  buttonCancel = 'modal-upd-address_button-cancel',
}

export enum QaUpdatePasswordModal {
  modalUpdatePassword = 'modal-upd-password_modal',
  inputCurrentPassword = 'modal-upd-password_input-current-password',
  inputNewPassword = 'modal-upd-password_input-new-password',
  inputConfirmNewPassword = 'modal-upd-password_input-confirm-new-password',
  buttonSaveChanges = 'modal-upd-password_button-save-changes',
  alertInputErrorMessage = 'modal-upd-password_error-',
  textTitle = 'modal-upd-password_text-title',
  textDescription = 'modal-upd-password_text-description',
}

export enum QaPasswordManagerPage {
  buttonAddPassword = 'passwords-page_button-add-password',
  buttonSearchPassword = 'passwords-page_button-search-password',
  inputSearchPassword = 'passwords-page_input-search-password',
  buttonPasswordContainers = 'passwords-page_button-password-containers',
  buttonPasswordCard = 'passwords-page_button-password-card_',
  dropdownPasswordCard = 'passwords-page_dropdown-password-card_',
  textTitleNoPasswords = 'passwords-page_title_no_passwords',
  linkMorePasswords = 'passwords-page_link-more_passwords',
  textPasswordCount = 'passwords-page_password-count',
}

export enum QaPasswordManagerDetailsPage {
  textAccountTitle = 'pm-details-page_account-title',
  textWebsite = 'pm-details-page_website',
  textUsername = 'pm-details-page_username',
  textPassword = 'pm-details-page_password',
  textNotes = 'pm-details-page_notes',
  buttonRevealPassword = 'pm-details-page_button-reveal-password',
  buttonHidePassword = 'pm-details-page_button-hide-password',
}

export enum QaAddPasswordInPMModal {
  inputWebsiteAddress = 'modal-add-password_input-website-address',
  inputAccountName = 'modal-add-password_input-account-name',
  inputUsername = 'modal-add-password_input-username',
  inputPassword = 'modal-add-password_input-password',
  inputNotes = 'modal-add-password_input-notes',
  textPasswordStrength = 'modal-add-password_password-strength',
  buttonSaveInVault = 'modal-add-password_button-save-in-vault',
}

export enum QaDeletePasswordInPMModal {
  buttonDelete = 'modal-delete-password_button-delete',
}

export enum QAConvertToPayModal {
  buttonBillingOffer = 'modal-ctp_button-billing-offer',
  textPlanInfo = 'modal-ctp_text-plan-info',
  textPlanPrice = 'modal-ctp_text-plan-price',
  alertPaymentError = 'modal-ctp_alert-payment-error',
}

export enum QaOffersAndUpgradesPage {
  textPageTitle = 'offers-and-upgrades-page_text-page-title',
  containerBreadcrumb = 'offers-and-upgrades-page_container-breadcrumb',
  textNoOffers = 'offers-and-upgrades-page_text-no-offers',
  textPaymentProcessing = 'offers-and-upgrades-page_text-payment-processing',
  buttonBillingTermToggle = 'offers-and-upgrades-page_button-billing-term-toggle',
  buttonPlanTypeToggle = 'offers-and-upgrades-page_button-plan-type-toggle',
  cardPlan = 'offers-and-upgrades-page_card-plan-',
  badgeCurrentPlan = 'offers-and-upgrades-page_badge-current-plan',
  badgeRecommendedPlan = 'offers-and-upgrades-page_badge-recommended-plan',
  textPlanName = 'offers-and-upgrades-page_text-plan-name',
  textPlanPrice = 'offers-and-upgrades-page_text-plan-price',
  buttonSelectPlan = 'offers-and-upgrades-page_button-select-plan',
}

export enum QaOrderSummaryModal {
  containerModal = 'modal-order-summary_container-modal',
  textModalTitle = 'modal-order-summary_text-modal-title',
  textPlanName = 'modal-order-summary_text-plan-name',
  textPrice = 'modal-order-summary_text-price',
  textTaxLabel = 'modal-order-summary_text-tax-label',
  textPaymentMethodOnFile = 'modal-order-summary_text-payment-method-on-file',
  checkboxAutoRenewTerms = 'modal-order-summary_checkbox-auto-renew-terms',
  checkboxChargeTerms = 'modal-order-summary_checkbox-charge-terms',
  checkboxCreditReportAuthorization = 'modal-order-summary_checkbox-credit-report-authorization',
  textConfirm = 'modal-order-summary_text-confirm',
  textUpsellTerms = 'modal-order-summary_text-upsell-terms',
}

export enum QAMyPlanPage {
  buttonKeepPlan = 'my-plan-page_button-keep-plan',
  textCompUser = 'my-plan-page_text-comp-user',
  textPreCtpUser = 'my-plan-page_text-pre-ctp-user',
  textPostCtpUser = 'my-plan-page_text-post-ctp-user',
  textPaymentInfo = 'my-plan-page_text-payment-info',
  textBillingAutoRenew = 'my-plan-page_text-auto-renew',
  checkboxAutoRenew = 'my-plan-page_checkbox-auto-renew',
  textBillingAlert = 'my-plan-page_text-billing-alert',
  textPlanExpiration = 'my-plan-page_plan-expiration',
  buttonCancelMembership = 'my-plan-page_button-cancel-membership',
  radioCurrentTerm = 'my-plan-page_radio-current-term',
  textPlanChangeBlocked = 'my-plan-page_text-plan-change-blocked',
  textNonPrimaryPlanName = 'my-plan-page_text-non-primary-plan-name',
  textNonPrimaryPayer = 'my-plan-page_text-non-primary-payer',
}

export enum QaDataCollectionModal {
  inputEmail = 'component-data-collection_input-email',
  inputFirstName = 'component-data-collection_input-first-name',
  inputMiddleName = 'component-data-collection_input-middle-name',
  inputLastName = 'component-data-collection_input-last-name',
  dropdownSuffix = 'component-data-collection_dropdown-suffix',

  inputAddress = 'component-data-collection_input-address',
  inputSuite = 'component-data-collection_input-suite',
  inputCity = 'component-data-collection_input-city',
  dropdownState = 'component-data-collection_dropdown-state',
  inputZip = 'component-data-collection_input-zip',

  inputBirthdate = 'component-data-collection_input-birthdate',
  inputPhoneNumber = 'component-data-collection_input_phone',
  inputSsn = 'component-data-collection_input_ssn',
  inputSSNConfirm = 'component-data-collection_input-ssn-confirm',

  // Service-authorization consent (credit-feature users only)
  checkboxServiceAuthorization = 'component-data-collection_checkbox-service-authorization',
  textServiceAuthorization = 'component-data-collection_text-service-authorization',

  // Step navigation (left "Previous" button on each form step)
  buttonBack = 'component-data-collection_button-back',

  // Error toast shown when submission fails
  alertError = 'component-data-collection_alert-error',

  inputLabel = 'component-data-collection_input-label_',
}

export enum QaInformationRequiredModal {
  textTitle = 'component-information-required_text-title',
  textDescription = 'component-information-required_text-description',
}

export enum QaTuidVerifyModal {
  // Intro screen
  textIntroTitle = 'component-tuid-verification_text-intro-title',
  textIntroDescription = 'component-tuid-verification_text-intro-description',
  buttonStart = 'component-tuid-verification_button-start',
  buttonDoThisLater = 'component-tuid-verification_button-do-this-later',

  // KBA question screen
  textQuestion = 'component-tuid-verification_text-question',
  // Answer choices — suffix with the option index (0-based)
  radioAnswerOption = 'component-tuid-verification_radio-answer-option_',
  buttonNext = 'component-tuid-verification_button-next',
  buttonSubmit = 'component-tuid-verification_button-submit',
  buttonCancel = 'component-tuid-verification_button-cancel',

  // OTP passcode screen
  // Delivery options — suffix with the option index (0-based)
  radioDeliveryOption = 'component-tuid-verification_radio-delivery-option_',
  // Segmented passcode inputs — suffix with the 1-based digit position
  inputPasscode = 'component-tuid-verification_input-passcode_',
  buttonResend = 'component-tuid-verification_button-resend',
  textPasscodeError = 'component-tuid-verification_text-passcode-error',

  // Response screen
  // Result icon — suffix with the icon key (success / failure / additional-verify / warning)
  iconResponse = 'component-tuid-verification_icon-response_',
  textResponseTitle = 'component-tuid-verification_text-response-title',
  textResponseMessage = 'component-tuid-verification_text-response-message',
  buttonClose = 'component-tuid-verification_button-close',
  buttonTryAgain = 'component-tuid-verification_button-try-again',
  buttonTryLater = 'component-tuid-verification_button-try-later',
  buttonContinue = 'component-tuid-verification_button-continue',

  // Cooldown (30-day lockout) modal
  textCooldownTitle = 'component-tuid-verification_text-cooldown-title',
  textCooldownDays = 'component-tuid-verification_text-cooldown-days',
  textCooldownMessage = 'component-tuid-verification_text-cooldown-message',
  buttonCooldownClose = 'component-tuid-verification_button-cooldown-close',
}

export enum QaIdauthVerifyModal {
  // DIT initial-check spinner
  textSpinnerTitle = 'component-idauth-verification_text-spinner-title',

  // Initial prompt (intro) screen
  textIntroTitle = 'component-idauth-verification_text-intro-title',
  buttonStart = 'component-idauth-verification_button-start',
  buttonDoThisLater = 'component-idauth-verification_button-do-this-later',

  // Method-select — DKBA quiz variant
  textMethodTitle = 'component-idauth-verification_text-method-title',
  buttonStartQuiz = 'component-idauth-verification_button-start-quiz',

  // DKBA quiz screen
  textQuestion = 'component-idauth-verification_text-question',
  // Answer choices — suffix with the option index (0-based)
  radioAnswerOption = 'component-idauth-verification_radio-answer-option_',
  buttonNext = 'component-idauth-verification_button-next',
  buttonSubmit = 'component-idauth-verification_button-submit',
  buttonCancel = 'component-idauth-verification_button-cancel',

  // Outcome (terminal) screen
  // Outcome root — suffix with the kebab-cased outcome code (e.g. dit-deny, quiz-success)
  outcomeRoot = 'component-idauth-verification_outcome_',
  textOutcomeTitle = 'component-idauth-verification_text-outcome-title',
  textOutcomeMessage = 'component-idauth-verification_text-outcome-message',
  // Action buttons — suffix with the action type (close / retry / continue)
  buttonAction = 'component-idauth-verification_button-',
}

export enum QAEnrollmentPage {
  inputCode = 'enrollment-page_input-',
  buttonRedeemCode = 'enrollment-page_button-redeem-code',
  textRedeemCodeError = 'enrollment-page_text-redeem-code-error',

  textInputPassword = 'enrollment-page_input-password',
  textInputConfirmPassword = 'enrollment-page_input-confirm-password',
  buttonCreateAccount = 'enrollment-page_button-create-account',
  textPasswordHints = 'enrollment-page_text-password-hints',
  textTermsOfService = 'enrollment-page_text-terms-of-service',
  linkTermsOfService = 'enrollment-page_link-terms-of-service',
  linkPrivacyPolicy = 'enrollment-page_link-privacy-policy',

  checkboxAuthorizeLicensor = 'enrollment-page_checkbox-authorize-licensor',
  textAuthorizeLicensor = 'enrollment-page_text-authorize-licensor',
  checkboxAgreeToServiceTerms = 'enrollment-page_checkbox-agree-to-service-terms',
  textAgreeToServiceTerms = 'enrollment-page_text-agree-to-service-terms',

  textPasswordHint_item = 'enrollment-page_text-password-hint-',

  checkboxEmailOptIn = 'enrollment-page_checkbox-email-opt-in',
  textEmailOptIn = 'enrollment-page_text-email-opt-in',

  buttonReturnToSignIn = 'enrollment-page_button-return-to-sign-in',

  buttonGoDashboard = 'enrollment-page_button-go-dashboard',
  textPlanSummaryDescription = 'enrollment-page_text-plan-summary-description',
  textPlanSummary = 'enrollment-page_text-plan-summary',
  textPlanName = 'enrollment-page_text-plan-name',
  textDueTodayAmount = 'enrollment-page_text-due-today-amount',
  checkboxAgreeToTerms = 'enrollment-page_checkbox-agree-to-terms',
  buttonContinueToPayment = 'enrollment-page_button-continue-to-payment',
}

export enum QaForgotPasswordPage {
  textTitle = 'forgot-password-page_text-title',
  textDescription = 'forgot-password-page_text-description',
  textInputLabel = 'forgot-password-page_text-input-label-',

  buttonReturnToSignIn = 'forgot-password-page_button-return-to-sign-in',
  buttonSubmit = 'forgot-password-page_button-submit',
}

export enum QaForgotUsernamePage {
  textTitle = 'forgot-username-page_text-title',
  textDescription = 'forgot-username-page_text-description',

  buttonReturnToSignIn = 'forgot-username-page_button-return-to-sign-in',
  buttonSubmit = 'forgot-username-page_button-submit',
}

export enum QaResetPasswordPage {
  textTitle = 'reset-password-page_text-title',
  textDescription = 'reset-password-page_text-description',

  inputPassword = 'reset-password-page_input-password',
  inputConfirmPassword = 'reset-password-page_input-confirm-password',

  textSignInTermsAndPolicy = 'reset-password-page_text-sign-in-terms-and-policy',
  linkTermsOfService = 'reset-password-page_link-terms-of-service',
  linkPrivacyPolicy = 'reset-password-page_link-privacy-policy',

  buttonSignIn = 'reset-password-page_button-sign-in',

  textToastAlert = 'reset-password-page_text-toast-alert',
}

export enum QaCheckYourEmail {
  textTitle = 'check-email-page_text-title',
  textDescription = 'check-email-page_text-description',

  buttonReturnToSignIn = 'check-email-page_button-return-to-sign-in',
}

export enum QaVerifyTokenPage {
  imageVerifyUser = 'verify-token-page_image-verify-user',
  textTitle = 'verify-token-page_text-title',
  alertErrorMessage = 'verify-token-page_alert-error-message',
  buttonReturnToSignIn = 'verify-token-page_button-return-to-sign-in',
}

export enum QaCreditCardCapture {
  buttonCompleteSetup = 'credit-card-capture_button-complete-setup',
  buttonSkipSetup = 'credit-card-capture_button-skip-setup',
  checkboxAutoRenewAgree = 'credit-card-capture_checkbox-auto-renew-agree',
  textModalDescription = 'credit-card-capture_text-modal-description',
  textModalTitle = 'credit-card-capture_text-modal-title',
  textBanner = 'credit-card-capture_text-banner',
}

export enum QaCtpBanner {
  bannerContainer = 'ctp-banner_container',
  textTitle = 'ctp-banner_title',
  textBody = 'ctp-banner_body',
  buttonCta = 'ctp-banner_button-cta',
  buttonClose = 'ctp-banner_button-close',
}

export enum QaAddCcBanner {
  bannerContainer = 'add-cc-banner_container',
  textTitle = 'add-cc-banner_title',
  textBody = 'add-cc-banner_body',
  buttonCta = 'add-cc-banner_button-cta',
  buttonClose = 'add-cc-banner_button-close',
}

export enum QaWhiteGloveBanner {
  bannerContainer = 'white-glove-banner_container',
  textTitle = 'white-glove-banner_title',
  textBody = 'white-glove-banner_body',
  buttonCta = 'white-glove-banner_button-cta',
}

export enum QaWhiteGloveCard {
  cardContainer = 'white-glove-card_container',
  textTitle = 'white-glove-card_title',
  textBody = 'white-glove-card_body',
  linkPhone = 'white-glove-card_link-phone',
}

export enum QaBannerCarousel {
  carouselContainer = 'banner-carousel_container',
  bannerItem = 'banner-carousel_item',
  buttonPrev = 'banner-carousel_button-prev',
  buttonNext = 'banner-carousel_button-next',
  indicatorDot = 'banner-carousel_indicator-dot',
}

export enum QaRecoveryKeyModal {
  textTitle = 'recovery-key-modal_text-title',
  textErrorMessage = 'recovery-key-modal_error-message',
  inputRecoveryKey = 'recovery-key-modal_input-recovery-key',
  buttonCancel = 'recovery-key-modal_button-cancel',
  buttonContinue = 'recovery-key-modal_button-continue',
}

export enum QaCreateMasterPasswordModal {
  textTitle = 'create-master-password-modal_text-title',
  textDescription = 'create-master-password-modal_text-description',
  inputMasterPassword = 'create-master-password-modal_input-master-password',
  inputConfirmMasterPassword = 'create-master-password-modal_input-confirm-master-password',
  textMasterPasswordHintItem = 'create-master-password-modal_text-password-hint-',
  buttonCancel = 'create-master-password-modal_button-cancel',
  buttonContinue = 'create-master-password-modal_button-continue',
}

export enum QaRecoveryKeyDownloadModal {
  containerModal = 'recovery-key-download-modal_container-modal',
  textTitle = 'recovery-key-download-modal_text-title',
  textDescription = 'recovery-key-download-modal_text-description',
  textRecoveryKeyLabel = 'recovery-key-download-modal_text-recovery-key-label',
  fieldRecoveryKey = 'recovery-key-download-modal_field-recovery-key',
  iconCopy = 'recovery-key-download-modal_icon-copy',
  buttonDownloadAndFinish = 'recovery-key-download-modal_button-download-and-finish',
}

export enum QaPasswordDefensePage {
  textPageTitle = 'password-defense-page_text-page-title',
  textPageDescription = 'password-defense-page_text-page-description',

  // Passwords Card Locators
  containerPasswordsCard = 'password-defense-page_container-passwords-card',
  iconPasswords = 'password-defense-page_icon-passwords',
  textTitlePasswordCard = 'password-defense-page_text-password-card-title',
  textDescriptionPasswordCard = 'password-defense-page_text-password-card-description',
  containerWebsiteLogos = 'password-defense-page_container-website-logos',

  // "For this device" section Locators
  textTitleThisDevice = 'password-defense-page_text-title-this-device',
  iconPasswordDefenseThisDevice = 'password-defense-page_icon-password-defense-this-device',
  textSubtitleThisDevice = 'password-defense-page_text-subtitle-this-device',
  textDescriptionThisDevice = 'password-defense-page_text-description-this-device',
  containerPlatformsThisDevice = 'password-defense-page_container-platforms-this-device',
  buttonInstall = 'password-defense-page_button-install',
  textAlreadyInstalled = 'password-defense-page_text-already-installed',
  buttonLoginIntoPm = 'password-defense-page_button-login-into-pm',

  // "For mobile device" section Locators
  textTitleMobileDevice = 'password-defense-page_text-title-mobile-device',
  iconPasswordDefenseMobileDevice = 'password-defense-page_icon-password-defense-mobile-device',
  textSubtitleMobileDevice = 'password-defense-page_text-subtitle-mobile-device',
  textDescriptionMobileDevice = 'password-defense-page_text-description-mobile-device',
  containerPlatformsMobileDevice = 'password-defense-page_container-platforms-mobile-device',
  qrCodeMobileDevice = 'password-defense-page_qr-code-mobile-device',
}

export enum QaVpnInTouchPage {
  textPageTitle = 'vpn-in-touch-page_text-page-title',
  textPageDescription = 'vpn-in-touch-page_text-page-description',

  // Get VPN In Touch section
  containerGetVpnInTouch = 'vpn-in-touch-page_container-get-vpn-in-touch',
  iconVpnInTouch = 'vpn-in-touch-page_icon-vpn-in-touch',
  textTitleGetVpnInTouch = 'vpn-in-touch-page_text-title-get-vpn-in-touch',
  textDescriptionGetVpnInTouch = 'vpn-in-touch-page_text-description-get-vpn-in-touch',
  textUserEmail = 'vpn-in-touch-page_text-user-email',
  textAvailableOn = 'vpn-in-touch-page_text-available-on',
  containerOsPlatforms = 'vpn-in-touch-page_container-os-platforms',
  buttonInstall = 'vpn-in-touch-page_button-install',

  // Login into VPN section
  buttonLoginIntoVpn = 'vpn-in-touch-page_button-login-into-vpn',

  // What Does VPN Do Section
  textTitleWhatDoesVpnDo = 'vpn-in-touch-page_text-title-what-does-vpn-do',
  containerItemWhatDoesVpnDo = 'vpn-in-touch-page_container-item-what-does-vpn-do',
  iconItemWhatDoesVpnDo = 'vpn-in-touch-page_icon-what-does-vpn-do_item-',
  textTitleItemWhatDoesVpnDo = 'vpn-in-touch-page_text-title-what-does-vpn-do_item-',
  textDescriptionItemWhatDoesVpnDo = 'vpn-in-touch-page_text-description-what-does-vpn-do_item-',
}

export enum QADashboardPageCreditScore {
  cardCreditScore = 'dashboard-page_credit-score_card',
  iconSpeedometer = 'dashboard-page_credit-score_icon-speedometer',
  testCardTitle = 'dashboard-page_credit-score_card-title',
  textLastUpdated = 'dashboard-page_credit-score_text-last-updated',
  buttonViewFullReport = 'dashboard-page_credit-score_button-view-full-report',

  // Credit Score card when Identity Verification is not completed
  iconVerifyIdentity = 'dashboard-page_credit-score_icon-verify-identity',
  textVerifyIdentity = 'dashboard-page_credit-score_text-verify-identity',
  buttonVerifyIdentity = 'dashboard-page_credit-score_button-verify-identity',
}

export enum QADashboardPageCreditReport {
  cardCreditReport = 'dashboard-page_credit-report_card',
  iconCreditReport = 'dashboard-page_credit-report_icon-credit-report',
  textCardTitle = 'dashboard-page_credit-report_card-title',
  textCardDescription = 'dashboard-page_credit-report_card-description',
  textNextReportDate = 'dashboard-page_credit-report_text-next-report-date',
  buttonRequestReport = 'dashboard-page_credit-report_button-request-report',

  // Credit Report card — not activated (missing PII)
  buttonActivateCreditReport = 'dashboard-page_credit-report_button-activate-credit-report',
  iconActivationInProgress = 'dashboard-page_credit-report_icon-activation-in-progress',
  textActivationInProgressDescription = 'dashboard-page_credit-report_text-activation-in-progress-description',

  // Credit Report card when Identity Verification is not completed
  buttonVerifyIdentity = 'dashboard-page_credit-report_button-verify-identity',
}

export enum QaCreditReportPage {
  // Shared page header (CreditReportPageHeader) — used on activate/verify/
  // loading/request/failed/bureau-list states
  textPageTitle = 'credit-report-page_text-page-title',
  textPageDescription = 'credit-report-page_text-page-description',

  // Shared report-view header (CreditReportViewPageHeader) — used once a
  // report is ready and rendered (bureau detail views)
  textReportViewTitle = 'credit-report-page_text-report-view-title',
  textReportDate = 'credit-report-page_text-report-date',
  buttonPrint = 'credit-report-page_button-print',

  // Not-activated state (shared/activate-credit-report)
  containerNotActivated = 'credit-report-page_container-not-activated',
  iconNotActivated = 'credit-report-page_icon-not-activated',
  textTitleNotActivated = 'credit-report-page_text-title-not-activated',
  textDescriptionNotActivated = 'credit-report-page_text-description-not-activated',
  buttonActivateNow = 'credit-report-page_button-activate-now',
  containerActivationInProgress = 'credit-report-page_container-activation-in-progress',
  iconActivationInProgress = 'credit-report-page_icon-activation-in-progress',
  textTitleActivationInProgress = 'credit-report-page_text-title-activation-in-progress',
  textDescriptionActivationInProgress = 'credit-report-page_text-description-activation-in-progress',

  // Verify-identity state (shared/verify-identity)
  containerVerifyIdentity = 'credit-report-page_container-verify-identity',
  iconUserCheck = 'credit-report-page_icon-user-check',
  textTitleVerifyIdentity = 'credit-report-page_text-title-verify-identity',
  textDescriptionVerifyIdentity = 'credit-report-page_text-description-verify-identity',
  buttonVerifyNow = 'credit-report-page_button-verify-now',

  // Bureau selector list (shared/bureau-selector-list)
  containerBureauList = 'credit-report-page_container-bureau-list',
  buttonBureauCard = 'credit-report-page_button-bureau-card-',
  iconBureauLogo = 'credit-report-page_icon-bureau-logo-',
  textBureauName = 'credit-report-page_text-bureau-name-',

  // Request credit report (shared/request-credit-report)
  textTitleRequestReport = 'credit-report-page_text-title-request-report',
  textDescriptionEligibility = 'credit-report-page_text-description-eligibility',
  textLegalDisclosure = 'credit-report-page_text-legal-disclosure',
  textAuthorizationStatement = 'credit-report-page_text-authorization-statement',
  buttonRequestReport = 'credit-report-page_button-request-report',

  // Did you know (shared/request-credit-report/did-you-know)
  containerDidYouKnow = 'credit-report-page_container-did-you-know',
  textDidYouKnowTitle = 'credit-report-page_text-did-you-know-title',

  // New report available banner (shared/request-new-report-banner)
  containerNewReportBanner = 'credit-report-page_container-new-report-banner',
  textNewReportBannerTitle = 'credit-report-page_text-new-report-banner-title',
  textNewReportBannerDescription = 'credit-report-page_text-new-report-banner-description',
  buttonRequestNewReport = 'credit-report-page_button-request-new-report',

  // Loading screen (shared/credit-report-loading-screen)
  containerLoading = 'credit-report-page_container-loading',
  textTitleLoading = 'credit-report-page_text-title-loading',
  textDescriptionLoading = 'credit-report-page_text-description-loading',

  // Report-failed state — shared value set across crtb/tbcr/one-bureau/
  // three-b report-failed components (each renders exactly one, never more
  // than one at a time). buttonRetry only renders in the CRTB variant.
  containerReportFailed = 'credit-report-page_container-report-failed',
  textTitleReportFailed = 'credit-report-page_text-title-report-failed',
  textDescriptionReportFailed = 'credit-report-page_text-description-report-failed',
  buttonRetry = 'credit-report-page_button-retry',

  // Accounts section (shared/sections/SharedAccounts)
  containerAccountsSection = 'credit-report-page_container-accounts-section',
  textAccountsTitle = 'credit-report-page_text-accounts-title',
  toggleAccountsTab = 'credit-report-page_toggle-accounts-tab',
  textEmptyAccountsMessage = 'credit-report-page_text-empty-accounts-message',
  containerAccountRow = 'credit-report-page_container-account-row',

  // Account summary table (shared/sections/AccountSummaryTable)
  containerAccountSummary = 'credit-report-page_container-account-summary',
  cardSummaryCategory = 'credit-report-page_card-summary-category-',
  iconSummaryCategory = 'credit-report-page_icon-summary-category-',
  textSummaryCategoryTitle = 'credit-report-page_text-summary-category-title-',
  textSummaryStatValue = 'credit-report-page_text-summary-stat-value-',

  // Need to report a problem (shared/sections/SharedReportProblem +
  // CreditorContactInfo)
  containerReportProblem = 'credit-report-page_container-report-problem',
  textReportProblemTitle = 'credit-report-page_text-report-problem-title',
  textReportProblemDescription = 'credit-report-page_text-report-problem-description',
  textVerificationPin = 'credit-report-page_text-verification-pin',
  textBureauContactInfo = 'credit-report-page_text-bureau-contact-info',
  containerCreditorContactTable = 'credit-report-page_container-creditor-contact-table',

  // FAQ (shared/credit-report-faq) — only the outer wrapper is labelable;
  // the toggle button and question items live in the shared FaqSection
  // component, which has no qaSelector prop to attach to.
  containerFaq = 'credit-report-page_container-faq',

  // Credit report score card (shared/sections/CreditReportScoreCard) —
  // internals reuse pages/credit-score's QaCreditScorePage selectors
  containerScoreCard = 'credit-report-page_container-score-card',

  // Three-b verification PIN (three-b/AccountPin)
  containerAccountPin = 'credit-report-page_container-account-pin',
  textAccountPinValue = 'credit-report-page_text-account-pin-value',
}

export enum QaCreditScorePage {
  textPageTitle = 'credit-score-page_text-page-title',
  textPageDescription = 'credit-score-page_text-page-description',
  iconTime = 'credit-score-page_icon-time',
  textLastUpdatedDate = 'credit-score-page_text-last-updated-date',

  // Credit Score Graph
  scoreGraphContainer = 'credit-score-page_container-score-graph',
  bureauIcon = 'credit-score-page_icon-bureau-',
  textScore = 'credit-score-page_text-score',
  textScoreLabel = 'credit-score-page_text-score-label',
  textScoreProgress = 'credit-score-page_text-score-progress',
  barProgressIndicatorContainer = 'credit-score-page_bar-progress-indicator-container',
  barProgressIndicator = 'credit-score-page_bar-progress-indicator-',
  barProgressCircle = 'credit-score-page_bar-progress-circle-',

  textScoreMinRange = 'credit-score-page_text-score-min-range',
  textScoreMaxRange = 'credit-score-page_text-score-max-range',
  divider = 'credit-score-page_divider',
  barLegendIndicator = 'credit-score-page_bar-legend-indicator-',
  textLegendLabel = 'credit-score-page_text-legend-label-',
  textLegendRange = 'credit-score-page_text-legend-range-',

  // Credit Score Factors
  textTitleScoreFactors = 'credit-score-page_text-title-score-factors',
  containerFactorsItems = 'credit-score-page_container-factors-items',
  textFactorTitle = 'credit-score-page_text-factor-title',
  textFactorStatusBadge = 'credit-score-page_text-factor-status-badge',
  containerFactorContent = 'credit-score-page_container-factor-content',
  textTitleExplanationSection = 'credit-score-page_text-title-explanation-section',
  textDescriptionExplanationSection = 'credit-score-page_text-description-explanation-section',
  textTitleWhatYouCanDoSection = 'credit-score-page_text-title-what-you-can-do-section',
  textDescriptionWhatYouCanDoSection = 'credit-score-page_text-description-what-you-can-do-section',

  // Credit Score page in unavailable state
  containerUnavailableState = 'credit-score-page_container-unavailable-state',
  bureauIconUnavailableState = 'credit-score-page_icon-bureau-unavailable-state',
  textTitleUnavailableState = 'credit-score-page_text-title-unavailable-state',
  textDescriptionUnavailableState = 'credit-score-page_text-description-unavailable-state',
  textAssistanceUnavailableState = 'credit-score-page_text-assistance-unavailable-state',

  // Credit Score page when Identity Verification is not completed
  containerVerifyIdentity = 'credit-score-page_container-verify-identity',
  iconUserCheck = 'credit-score-page_icon-user-check',
  textTitleVerifyIdentity = 'credit-score-page_text-title-verify-identity',
  textDescriptionVerifyIdentity = 'credit-score-page_text-description-verify-identity',
  buttonVerifyNow = 'credit-score-page_button-verify-now',
  buttonCompleteSetup = 'credit-score-page_button-complete-setup',
}

export enum QaCreditScoreSimulatorPage {
  // Page chrome
  textPageTitle = 'credit-score-simulator-page_text-page-title',
  iconExperianBadge = 'credit-score-simulator-page_icon-experian-badge',
  textPageDescription = 'credit-score-simulator-page_text-page-description',

  // Finish-setup state (missing PII)
  containerFinishSetup = 'credit-score-simulator-page_container-finish-setup',
  textTitleFinishSetup = 'credit-score-simulator-page_text-title-finish-setup',
  textDescriptionFinishSetup = 'credit-score-simulator-page_text-description-finish-setup',
  buttonFinishSetup = 'credit-score-simulator-page_button-finish-setup',

  // Verify-identity state
  containerVerifyIdentity = 'credit-score-simulator-page_container-verify-identity',
  iconUserCheck = 'credit-score-simulator-page_icon-user-check',
  textTitleVerifyIdentity = 'credit-score-simulator-page_text-title-verify-identity',
  textDescriptionVerifyIdentity = 'credit-score-simulator-page_text-description-verify-identity',
  buttonVerifyNow = 'credit-score-simulator-page_button-verify-now',

  // Technical-issue state
  containerTechnicalIssue = 'credit-score-simulator-page_container-technical-issue',
  iconWarning = 'credit-score-simulator-page_icon-warning',
  textTitleTechnicalIssue = 'credit-score-simulator-page_text-title-technical-issue',
  textDescriptionTechnicalIssue = 'credit-score-simulator-page_text-description-technical-issue',
  buttonRetry = 'credit-score-simulator-page_button-retry',

  // Unavailable state
  containerUnavailableState = 'credit-score-simulator-page_container-unavailable-state',
  iconUnavailable = 'credit-score-simulator-page_icon-unavailable',
  textTitleUnavailableState = 'credit-score-simulator-page_text-title-unavailable-state',
  textDescriptionUnavailableState = 'credit-score-simulator-page_text-description-unavailable-state',
  textAssistanceUnavailableState = 'credit-score-simulator-page_text-assistance-unavailable-state',

  // Content (SHOW_CONTENT)
  textContentHeader = 'credit-score-simulator-page_text-content-header',
  textCategoryTitle = 'credit-score-simulator-page_text-category-title',

  // Scenario accordion — base string + scenario code suffix (e.g. ...text-scenario-XPPREA)
  textScenarioLabel = 'credit-score-simulator-page_text-scenario-',
  iconScenario = 'credit-score-simulator-page_icon-scenario-',

  // Expanded scenario detail
  textDetailDescription = 'credit-score-simulator-page_text-detail-description',
  containerSimulationTable = 'credit-score-simulator-page_container-simulation-table',
  textTableHeaderCell = 'credit-score-simulator-page_text-table-header-cell',
  containerTableRow = 'credit-score-simulator-page_container-table-row',
  textTableDataCell = 'credit-score-simulator-page_text-table-data-cell',
  dividerTableRow = 'credit-score-simulator-page_divider-table-row',
  textTryAgainBanner = 'credit-score-simulator-page_text-try-again-banner',
}

export enum QaCreditTrackerPage {
  textPageTitle = 'credit-tracker-page_text-page-title',
  textPageDescription = 'credit-tracker-page_text-page-description',
  iconTime = 'credit-tracker-page_icon-time',
  textLastUpdatedDate = 'credit-tracker-page_text-last-updated-date',

  // Score Tracker Graph
  containerScoreTrackerGraph = 'credit-tracker-page_container-score-tracker-graph',
  containerScoreTracker = 'credit-tracker-page_container-score-tracker',
  divider = 'credit-tracker-page_divider',

  // Score history table
  textTitleScoreHistory = 'credit-tracker-page_text-title-score-history',
  containerScoreHistoryTable = 'credit-tracker-page_container-score-history-table',

  // Feature activation status — Not activated
  containerNotActivated = 'credit-tracker-page_container-not-activated',
  iconNotActivated = 'credit-tracker-page_icon-not-activated',
  textTitleNotActivated = 'credit-tracker-page_text-title-not-activated',
  textDescriptionNotActivated = 'credit-tracker-page_text-description-not-activated',
  buttonActivateNow = 'credit-tracker-page_button-activate-now',

  // Feature activation status — Activation in progress
  containerActivationInProgress = 'credit-tracker-page_container-activation-in-progress',
  iconActivationInProgress = 'credit-tracker-page_icon-activation-in-progress',
  textTitleActivationInProgress = 'credit-tracker-page_text-title-activation-in-progress',
  textDescriptionActivationInProgress = 'credit-tracker-page_text-description-activation-in-progress',

  // Verify identity
  containerVerifyIdentity = 'credit-tracker-page_container-verify-identity',
  iconUserCheck = 'credit-tracker-page_icon-user-check',
  textTitleVerifyIdentity = 'credit-tracker-page_text-title-verify-identity',
  textDescriptionVerifyIdentity = 'credit-tracker-page_text-description-verify-identity',
}

export enum QaCreditLockPage {
  // Page-level
  textPageTitle = 'credit-lock-page_text-page-title',
  textPageDescription = 'credit-lock-page_text-page-description',
  iconExperianLogo = 'credit-lock-page_icon-experian-logo',

  // Status card
  cardStatus = 'credit-lock-page_card-status',
  iconPadlock = 'credit-lock-page_icon-padlock',
  textStatusHeading = 'credit-lock-page_text-status-heading',
  badgeStatus = 'credit-lock-page_badge-status',
  textStatusDescription = 'credit-lock-page_text-status-description',
  buttonAction = 'credit-lock-page_button-action',

  // Educational section
  containerEducation = 'credit-lock-page_container-education',
  cardEducation = 'credit-lock-page_card-education',
  textEducationCardTitle = 'credit-lock-page_text-education-card-title',
  textEducationCardDescription = 'credit-lock-page_text-education-card-description',
}

export enum QADashboardPageMedicalDataMonitoring {
  cardMedicalDataMonitoring = 'dashboard-page_medical-data-monitoring_card',
  iconMedicalData = 'dashboard-page_medical-data-monitoring_icon-medical-data',
  textCardTitle = 'dashboard-page_medical-data-monitoring_card-title',
  textItemsBadge = 'dashboard-page_medical-data-monitoring_items-badge',
  textCardDescription = 'dashboard-page_medical-data-monitoring_card-description',
  iconHealth = 'dashboard-page_medical-data-monitoring_icon-health',
  iconMedicalRecords = 'dashboard-page_medical-data-monitoring_icon-medical-records',
  iconMedicalBeneficiary = 'dashboard-page_medical-data-monitoring_icon-medical-beneficiary',
  iconNationalProvider = 'dashboard-page_medical-data-monitoring_icon-national-provider',
  iconInternationalClassificationOfDiseases = 'dashboard-page_medical-data-monitoring_icon-icd',
  buttonAddItem = 'dashboard-page_medical-data-monitoring_button-add-item',
}

export enum QaMedicalDataMonitoringPage {
  textPageTitle = 'medical-data-monitoring-page_text-page-title',
  textPageDescription = 'medical-data-monitoring-page_text-page-description',

  // Medical Data Card
  containerMedicalDataCard = 'mdm-page_container-medical-data-card',
  medicalDataTitleElements = 'mdm-page_medical-data-title-element',

  // International Classification of Diseases (ICD) Card
  iconInternationalClassificationOfDiseases = 'medical-data-monitoring-page_icon-icd',
  textInternationalClassificationOfDiseasesDescription = 'medical-data-monitoring-page_text-icd-description',
}

export enum QaWalletProtectionPage {
  textPageTitle = 'wallet-protection-page_text-page-title',
  textPageDescription = 'wallet-protection-page_text-page-description',
  bannerHelp = 'wallet-protection-page_banner-help',
  textBannerHelp = 'wallet-protection-page_text-banner-help',
  textTitleWhatToExpect = 'wallet-protection-page_text-title-what-to-expect',
  textSubtitleNextStep = 'wallet-protection-page_text-subtitle-next-step',
  textTitleQuickTips = 'wallet-protection-page_text-title-quick-tips',
  textSubtitleQuickTips = 'wallet-protection-page_text-subtitle-quick-tips',
}

export enum QaDashboardPageWalletProtection {
  cardWalletProtection = 'dashboard-page_card-wallet-protection',
  cardTitle = 'dashboard-page_card-wallet-protection-title',
  cardIcon = 'dashboard-page_card-wallet-protection-icon',
  cardLearnMore = 'dashboard-page_card-wallet-protection-learn-more',
}

export enum QaFinancialCalculatorPage {
  textPageTitle = 'financial-calculator-page_text-page-title',
  textPageDescription = 'financial-calculator-page_text-page-description',
  // Tile card — suffix with the calculator code (e.g. `-HomeBudget`).
  tileCard = 'financial-calculator-page_tile-card_',
  detailContainer = 'financial-calculator-page_detail-container',
  detailIframe = 'financial-calculator-page_detail-iframe',
  detailTitle = 'financial-calculator-page_text-detail-title',
  detailDescription = 'financial-calculator-page_text-detail-description',
}

export enum QaSpendingTrackerPage {
  page = 'spending-tracker-page',
  textPageTitle = 'spending-tracker-page_text-page-title',
  textPageDescription = 'spending-tracker-page_text-page-description',
  // Tab buttons — the antd Tabs component renders both tab keys as one control.
  tabCategory = 'spending-tracker-page_tab-category',
  tabOvertime = 'spending-tracker-page_tab-overtime',
  // Time-frame dropdown (antd Select).
  timeframeSelect = 'spending-tracker-page_timeframe-select',
  // Chart canvases — one per tab; suffix omitted since they never render together.
  chartCategory = 'spending-tracker-page_chart-category',
  chartOvertime = 'spending-tracker-page_chart-overtime',
  // Empty state.
  emptyState = 'spending-tracker-page_empty-state',
  emptyStateCta = 'spending-tracker-page_empty-state-cta',
  // Details modal.
  modalContainer = 'spending-tracker-page_modal-container',
  modalCloseButton = 'spending-tracker-page_modal-close',
  modalTransactionList = 'spending-tracker-page_modal-transaction-list',
}

export enum QaDashboardPageSpendingTracker {
  cardSpendingTracker = 'dashboard-page_card-spending-tracker',
  cardTitle = 'dashboard-page_card-spending-tracker-title',
  cardChart = 'dashboard-page_card-spending-tracker-chart',
  cardEmptyState = 'dashboard-page_card-spending-tracker-empty-state',
  cardCta = 'dashboard-page_card-spending-tracker-cta',
}

export enum QaInsightsAndTipsPage {
  page = 'insights-and-tips-page',
  textPageTitle = 'insights-and-tips-page_text-page-title',
  textPageDescription = 'insights-and-tips-page_text-page-description',
  breadcrumbsHome = 'insights-and-tips-page_breadcrumbs-home',
  breadcrumbsListing = 'insights-and-tips-page_breadcrumbs-listing',
  articleCard = 'insights-and-tips-page_article-card',
  articleCardTitle = 'insights-and-tips-page_article-card-title',
  articleCardCategory = 'insights-and-tips-page_article-card-category',
  articleCardDate = 'insights-and-tips-page_article-card-date',
  articleCardImage = 'insights-and-tips-page_article-card-image',
  paginationTotal = 'insights-and-tips-page_pagination-total',
  paginationControls = 'insights-and-tips-page_pagination-controls',
  emptyState = 'insights-and-tips-page_empty-state',
  errorState = 'insights-and-tips-page_error-state',
}

export enum QaInsightsAndTipsArticlePage {
  page = 'insights-and-tips-article-page',
  breadcrumbsHome = 'insights-and-tips-article-page_breadcrumbs-home',
  breadcrumbsListing = 'insights-and-tips-article-page_breadcrumbs-listing',
  breadcrumbsCurrent = 'insights-and-tips-article-page_breadcrumbs-current',
  heroImage = 'insights-and-tips-article-page_hero-image',
  category = 'insights-and-tips-article-page_category',
  date = 'insights-and-tips-article-page_date',
  byline = 'insights-and-tips-article-page_byline',
  title = 'insights-and-tips-article-page_title',
  body = 'insights-and-tips-article-page_body',
  readFullArticle = 'insights-and-tips-article-page_read-full-article',
  otherInsightsSection = 'insights-and-tips-article-page_other-insights-section',
  otherInsightsViewAll = 'insights-and-tips-article-page_other-insights-view-all',
}

export enum QaDashboardPageInsightsAndTips {
  cardInsightsAndTips = 'dashboard-page_card-insights-and-tips',
  cardTitle = 'dashboard-page_card-insights-and-tips-title',
  cardViewAll = 'dashboard-page_card-insights-and-tips-view-all',
  cardArticle = 'dashboard-page_card-insights-and-tips-article',
}

export enum QaHomeTitleMonitoring {
  // Dashboard card
  card = 'dashboard-page_home-title-monitoring_card',
  iconCard = 'dashboard-page_home-title-monitoring_icon',
  // TextWithBadge base -> `${cardHeading}_title` and `${cardHeading}_badge`
  cardHeading = 'dashboard-page_home-title-monitoring_card-heading',
  textCardSubtitle = 'dashboard-page_home-title-monitoring_text-subtitle',

  // Add-property button (shared by the dashboard card and the feature page)
  buttonAddProperty = 'home-title-monitoring_button-add-property',

  // Feature page
  textPageTitle = 'home-title-monitoring-page_text-page-title',
  textPageDescription = 'home-title-monitoring-page_text-page-description',
  // TextWithBadge base -> `${registeredPropertiesHeading}_badge` is the X/5 counter
  registeredPropertiesHeading = 'home-title-monitoring-page_registered-properties-heading',
  textEmptyState = 'home-title-monitoring-page_text-empty-state',

  // Registered-property list item
  cardProperty = 'home-title-monitoring-page_card-property',
  linkProperty = 'home-title-monitoring-page_card-property-link',
  textPropertyAddress = 'home-title-monitoring-page_card-property-address',
  badgePropertyStatus = 'home-title-monitoring-page_card-property-status',
  buttonPropertyMore = 'home-title-monitoring-page_card-property-button-more',
  menuItemRemoveProperty = 'home-title-monitoring-page_card-property-menu-remove',

  // Add-property modal
  textAddModalTitle = 'component-htmon_text-add-property-modal-title',
  buttonAddModalSave = 'component-htmon_button-add-property-modal-save',
  buttonAddModalCancel = 'component-htmon_button-add-property-modal-cancel',

  // Remove-property modal
  textRemoveModalTitle = 'component-htmon_text-remove-property-modal-title',
  buttonRemoveModalRemove = 'component-htmon_button-remove-property-modal-remove',
  buttonRemoveModalCancel = 'component-htmon_button-remove-property-modal-cancel',

  // Registered-property detail page
  textDetailAddress = 'home-title-monitoring-detail-page_text-property-address',
  badgeDetailStatus = 'home-title-monitoring-detail-page_card-property-status',

  // Public Record Property (PRP) — stack-unified read-only feature (PI-11404).
  // Lives on /financial/home-title-monitoring; reuses the selectors above for the
  // dashboard card container/heading, page title/description, registered-properties
  // badge, empty state, property row link/address, and detail address.
  buttonViewProperties = 'dashboard-page_home-title-monitoring_button-view-properties',
  // Detail page: deed / assessment accordion sections.
  deedSectionTitle = 'home-title-monitoring-detail-page_deed-section-title',
  assessmentSectionTitle = 'home-title-monitoring-detail-page_assessment-section-title',
  deedInfo = 'home-title-monitoring-detail-page_deed-info',
  assessmentInfo = 'home-title-monitoring-detail-page_assessment-info',
  // Per-field value base. property-info appends `-<slugified-label>` (e.g.
  // `_field-document-type`, `_field-buyer-1`, `_field-assessee-2`).
  fieldValue = 'home-title-monitoring-detail-page_field',
}

// Financial Transaction Monitoring (PI-11387). Dashboard tile shown on the main
// dashboard when the user has the `transaction_monitoring` entitlement.
export enum QATransactionMonitoringCard {
  card = 'transaction-monitoring-card',
  textTitle = 'transaction-monitoring-card_text-title',
  textDescription = 'transaction-monitoring-card_text-description',
  buttonLinkAccount = 'transaction-monitoring-card_button-link-account',
}

// Financial Transaction Monitoring page (/financial/transaction-monitoring/*).
export enum QATransactionMonitoringPage {
  page = 'transaction-monitoring-page',
  textTitle = 'transaction-monitoring-page_text-title',
  textDescription = 'transaction-monitoring-page_text-description',
  linkAccountsLinked = 'transaction-monitoring-page_link-accounts-linked',
  buttonLinkAccount = 'transaction-monitoring-page_button-link-account',

  // Empty state — loaded, no linked accounts.
  textEmptyTitle = 'transaction-monitoring-page_text-empty-title',
  textEmptyDescription = 'transaction-monitoring-page_text-empty-description',

  // Transaction-history list status messages (loading / no results / error).
  // Mutually exclusive, so they share one selector scoped by the visible text.
  textStatusMessage = 'transaction-monitoring-page_text-status-message',

  // Transactions list. rowTransaction is on each transaction's card label, so
  // .count() gives the number of transaction rows on the current page; the
  // per-date group header shares one selector scoped by index.
  textDateHeader = 'transaction-monitoring-page_text-date-header',
  rowTransaction = 'transaction-monitoring-page_row-transaction',
  textTransactionName = 'transaction-monitoring-page_text-transaction-name',
  textTransactionAmount = 'transaction-monitoring-page_text-transaction-amount',
  // Expanded-row detail container; the label/value rows live inside it.
  transactionDetail = 'transaction-monitoring-page_transaction-detail',

  // Toolbar actions (desktop icon buttons).
  buttonSearch = 'transaction-monitoring-page_button-search',
  buttonFilters = 'transaction-monitoring-page_button-filters',
  buttonAlertSettings = 'transaction-monitoring-page_button-alert-settings',

  // Search bar (wrapper — reach the antd input via .locator('input')).
  searchBar = 'transaction-monitoring-page_search-bar',
  // Autocomplete suggestion — one per rendered suggestion. antd applies the
  // `option` role inconsistently across rows, so tests key off this instead.
  searchSuggestion = 'transaction-monitoring-page_search-suggestion',

  // Category icon (one per transaction row).
  categoryIcon = 'transaction-monitoring-page_category-icon',
}

// FTM Alert Settings modal (opened from the toolbar or the post-link flow).
export enum QATransactionMonitoringAlertSettings {
  title = 'transaction-monitoring-alert-settings_text-title',
  // One row per account; .count() gives the number of threshold rows.
  row = 'transaction-monitoring-alert-settings_row',
  // Threshold field wrapper — reach the antd input via .locator('input').
  threshold = 'transaction-monitoring-alert-settings_threshold',
  thresholdError = 'transaction-monitoring-alert-settings_threshold-error',
  buttonSave = 'transaction-monitoring-alert-settings_button-save',
  buttonCancel = 'transaction-monitoring-alert-settings_button-cancel',
}

// FTM Filter panel (opened from the toolbar Filters button).
export enum QATransactionMonitoringFilters {
  panel = 'transaction-monitoring-filters_panel',
  buttonReset = 'transaction-monitoring-filters_button-reset',
  // Account-type pills — the type key (all|depository|credit|investment|loan|other)
  // is appended, so a specific pill is `${pillAccountType}${key}`.
  pillAccountType = 'transaction-monitoring-filters_pill-',
  selectInstitution = 'transaction-monitoring-filters_select-institution',
  // Date pickers / amount inputs are wrappers — reach the antd input via .locator('input').
  dateStart = 'transaction-monitoring-filters_date-start',
  dateEnd = 'transaction-monitoring-filters_date-end',
  amountMin = 'transaction-monitoring-filters_amount-min',
  amountMax = 'transaction-monitoring-filters_amount-max',
  amountMinError = 'transaction-monitoring-filters_amount-min-error',
  amountMaxError = 'transaction-monitoring-filters_amount-max-error',
}

// FTM Your Accounts page (/financial/transaction-monitoring/your-accounts).
export enum QATransactionMonitoringYourAccounts {
  textTitle = 'transaction-monitoring-your-accounts_text-title',
  // One card per linked institution; .count() = institutions.
  institutionCard = 'transaction-monitoring-your-accounts_institution-card',
  textInstitutionName = 'transaction-monitoring-your-accounts_text-institution-name',
  buttonRemove = 'transaction-monitoring-your-accounts_button-remove',
  // One row per account; .count() = accounts across all institutions.
  accountRow = 'transaction-monitoring-your-accounts_account-row',
  buttonRelink = 'transaction-monitoring-your-accounts_button-relink',
}

// FTM Remove-account confirmation modal.
export enum QATransactionMonitoringRemoveAccount {
  title = 'transaction-monitoring-remove-account_text-title',
  buttonRemove = 'transaction-monitoring-remove-account_button-remove',
  buttonCancel = 'transaction-monitoring-remove-account_button-cancel',
}

// NCOA / Address-verification modal — one modal, three screens (review | confirm | edit). PI-11310.
export enum QaReviewContactDetails {
  modal = 'modal-review-contact_modal',
  textTitle = 'modal-review-contact_text-title',
  // Review (intro / periodic-verification) screen
  textReasons = 'modal-review-contact_text-reasons',
  buttonReview = 'modal-review-contact_button-review',
  // Review (NCOA "your address has been updated") screen
  textNewAddress = 'modal-review-contact_text-new-address',
  textPreviousAddress = 'modal-review-contact_text-previous-address',
  buttonUsePrevious = 'modal-review-contact_button-use-previous',
  buttonConfirmNewAddress = 'modal-review-contact_button-confirm-new-address',
  checkboxOptOutReview = 'modal-review-contact_checkbox-opt-out-review',
  // Confirm-your-contact-details screen
  textEmail = 'modal-review-contact_text-email',
  textPhone = 'modal-review-contact_text-phone',
  textAddress = 'modal-review-contact_text-address',
  buttonEdit = 'modal-review-contact_button-edit',
  buttonConfirm = 'modal-review-contact_button-confirm',
  // Update-contact-details (edit) screen
  buttonGoBack = 'modal-review-contact_button-go-back',
  buttonSave = 'modal-review-contact_button-save',
  checkboxOptOutEdit = 'modal-review-contact_checkbox-opt-out-edit',
}

// Social Media Monitoring page (/social-media-monitoring[/:childId]). PI-11420.
// Per-network selectors carry a trailing dash and are suffixed with the network
// value (facebook | instagram | twitter | youtube | linkedin) at the call site,
// matching the QaSecurityPage `divChannelItem`/`buttonMoreActions` pattern.
export enum QASocialMediaMonitoringPage {
  textPageTitle = 'social-media-monitoring-page_text-page-title',
  textPageSubtitle = 'social-media-monitoring-page_text-page-subtitle',
  textFetchError = 'social-media-monitoring-page_text-fetch-error',
  textAccountsCardTitle = 'social-media-monitoring-page_text-accounts-card-title',
  networkRow = 'social-media-monitoring-page_network-row-',
  textNetworkName = 'social-media-monitoring-page_text-network-name-',
  buttonConnect = 'social-media-monitoring-page_button-connect-',
  accountRow = 'social-media-monitoring-page_account-row-',
  textAccountUsername = 'social-media-monitoring-page_text-account-username-',
  textConnecting = 'social-media-monitoring-page_text-connecting-',
  textDisconnected = 'social-media-monitoring-page_text-disconnected-',
  buttonReconnect = 'social-media-monitoring-page_button-reconnect-',
  buttonRemove = 'social-media-monitoring-page_button-remove-',
  buttonMobileOverflow = 'social-media-monitoring-page_button-mobile-overflow-',
}

// Social Media "Connect account" modal (opened via the + on any network row).
export enum QASocialMediaConnectModal {
  textTitle = 'social-media-connect-modal_text-title',
  textInfoBanner = 'social-media-connect-modal_text-info-banner',
  textStepsIntro = 'social-media-connect-modal_text-steps-intro',
  // Five step rows render together — Playwright uses .count() / .nth(i)
  // to reach individual steps.
  textStep = 'social-media-connect-modal_text-step',
  buttonCancel = 'social-media-connect-modal_button-cancel',
  buttonConnect = 'social-media-connect-modal_button-connect',
}

// Social Media "Remove account" confirmation modal.
export enum QASocialMediaRemoveModal {
  textTitle = 'social-media-remove-modal_text-title',
  textBody = 'social-media-remove-modal_text-body',
  buttonCancel = 'social-media-remove-modal_button-cancel',
  buttonRemove = 'social-media-remove-modal_button-remove',
}

// Dashboard right-column quick-links card for Social Media Monitoring.
export enum QADashboardPageSocialMedia {
  cardContainer = 'dashboard-page-social-media_card-container',
  textCardTitle = 'dashboard-page-social-media_text-card-title',
  textCardBody = 'dashboard-page-social-media_text-card-body',
  buttonCta = 'dashboard-page-social-media_button-cta',
}
